import { useCallback, useEffect, useRef, useState } from "react";
import styles from "../reportSection.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Grid,
  Typography,
} from "@mui/material";
import { ReportToRender } from "../../common/RenderSubReports";
import TreasuryReportsTableData from "./TreasuryReportsTableData";
import TreasuryIncomeReportsTableData from "./TreasuryIncomeReportsTableData";
import IncomeReportTableData from "./IncomeReportTableData";
import { useReactToPrint } from "react-to-print";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomDownIcon,
  CustomLeftIcon,
  CustomUpIcon,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { apiRequest } from "../../../infrastructure/backendService";
import SpecialEventsReportsTableData from "./SpecialEventsReportsTableData";
import apiPath from "../../../config/apiPaths.json";
import LifeTimeDonarsTableData from "./LifeTimeDonarsTableData";
import PrintTreasuryReports from "./PrintTreasuryReports";
import ErrorPopup from "../../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import constants from "../../../config/constants.json";
import DonationPoojaReportTableData from "./DonationPoojaReportTableData";
import dayjs from "dayjs";

const TreasuryReports = ({ subReports }: any) => {
  const [reportName, setReportName] = useState("");
  const [reqBody, setReqBody] = useState("");
  const [resData, setResData] = useState("");
  const [totalDonatedAmount, setTotalDonatedAmount] = useState<any>();
  const [totalDrillDownData, setTotalDrillDownData] = useState<any>();
  const [requestBodyDrillDown, setRequestBodyDrillDown] = useState<any>();
  const [incomeReportReqBody, serIncomeReportReqBody] = useState<any>();
  const [excelData, setExcelData] = useState<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [printActive, setPrintActive] = useState(false);

  /* Data from Pooja Report Back to Main Report Section */
  const [dataFromChild, setDataFromChild] = useState(false);
  const [treasuryReportData, setTreasuryReportData] = useState<any[]>([]);
  const [columnData, setColumnData] = useState({});
  const [excelColumnData, setExcelColumnData] = useState({});
  const [subReportsAccordiansArray, setSubReportsAccordians] = useState(
    new Array(6).fill(false)
  );
  const [loading, setLoading] = useState(false);
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [subReportsName, setSubReportsName] = useState("");
  const [treasuryReportsReqBody,setTreasuryReportsReqBody] = useState<any>()
  const [isPrintTriggered, setIsPrintTriggered] = useState(false);
  const [formDataInfo, setFormDataInfo] = useState<any>('');
  const [totalCumAmt, setTotalCumAmt] = useState<number>(0);
  const [totalDonation, setTotalDonation] = useState<number>(0);
  const [totalPooja, setTotalPooja] = useState<number>(0);
  const [totalElements_DonationReport, setTotalElements_DonationReport] = useState<any>();
  const [pageSize_DonationReport, setPageSize_DonationReport] = useState<any>();
  const [devoteeName, setDevoteeName] = useState<string>("");
  const [selectYear, setSelectYear] = useState<any>("");
  const [selectMonth, setSelectMonth] = useState<any>("");
  const [selectQuarter, setSelectQuarter] = useState<any>("");
  const [selectStartDate, setSelectStartDate] = useState<any>("");
  const [selectEndDate, setSelectEndDate] = useState<any>("");

  function handleDataFromChild(data: any,{reqBody,reportName,formData,totalElements,pageSize,totalDonatedAmount,devoteename,dateObj}:any) {
    setDataFromChild(data);
    setReportName(reportName);    
    setTreasuryReportsReqBody(reqBody)
    setFormDataInfo(formData)
    if(reportName === 'IncomeReport'){
      serIncomeReportReqBody(reqBody)
    }else if(reportName === 'DrillDownReport'){
      setSubReportsName('Drill Down Report')
    }else if(reportName === 'Donation Pooja Report'){
      setSubReportsName('Donation Pooja Report')
    }else if(reportName === 'Donation Report'){
      setSubReportsName('Donation Report')
      setTotalElements_DonationReport(totalElements)
      setPageSize_DonationReport(pageSize)
    }else if(subReportsName === 'Revenue Reports' || subReportsName === 'Revenue Summary Report by Signin Name'){
      setTotalDonatedAmount(totalDonatedAmount)
      setTotalElements_DonationReport(totalElements)
      setPageSize_DonationReport(pageSize)
      setRequestBodyDrillDown(reqBody)
      setDevoteeName(devoteename)
      setSelectYear(dateObj.selectYear)
      setSelectMonth(dateObj.selectMonth)
      setSelectQuarter(dateObj.selectQuarter)
      setSelectStartDate(dateObj.startDate)
      setSelectEndDate(dateObj.endDate)
    }else if(subReportsName === 'Revenue Summary Report'){  
      setSelectYear(dateObj.selectYear)    
      setSelectMonth(dateObj.selectMonth)
      setSelectQuarter(dateObj.selectQuarter)
    }
  }

  function handleGoingBackToMainReportsSection() {
    // setDataFromChild(false);
    if (reportName === "DrillDownReport") {
      setDataFromChild(true);
      setReportName("IncomeReport");
      setSubReportsName('Income Report')
      getReportData(resData);
      setPrintActive(true)
    }else {
      setDataFromChild(false);      
      setTreasuryReportData([]);
      setColumnData([]);
    }
    setPrintActive(false)
    setSelectYear('')    
    setSelectMonth('')
    setSelectQuarter('')
  }

  function getReportData(data: any) { 
    if(subReportsName === 'Donation Pooja Report'){
      setTreasuryReportData(data);
    }
    if(subReportsName === 'Revenue Reports'){
      setTreasuryReportData(data);
      setDataFromChild(true)
    }

    // let columnHeaders = data[0];
    let columnHeaders;
    if(data[0].hasOwnProperty('userinfo')){
      const userInfo =  data.find((item:any)=>item.userinfo.length > 0)
       columnHeaders = userInfo.userinfo[0]
    }else{
      columnHeaders = data[0]
     
    } 
    let columns: any = {};
    for (let key of Object.keys(columnHeaders)) {
      columns[key] = key;
    }
    setTreasuryReportData(data);
    setColumnData(columns);
  }
  function getTotalDrillDownData(data: any) {
    setTotalDrillDownData(data);
    setTotalDonatedAmount(data?.totalDonatedAmount);
  }

  function getReqBodyAndResData(reqBody: any, resData: any) {
    setReqBody(reqBody);
    setResData(resData);
  }
  function sendDrillDownRequestBody(drilldownReqbody: any) {
    setRequestBodyDrillDown(drilldownReqbody);
  }
  const [expandedPanel, setExpandedPanel] = useState(null);

  const handleToggleChange = (index: any) => {
    setExpandedPanel(expandedPanel === index ? null : index);
    const accordianArray = [...subReportsAccordiansArray];
    accordianArray[index] = !accordianArray[index];
    setSubReportsAccordians(accordianArray);
    const reportObj = subReports.subMenus.find(
      (report: any, i: number) => i === index
    );
    setSubReportsName(reportObj.title);
  };

const PrintStyles = `
 @page {
      size: tabloid;
      margin: 24px;
    }  
    /* Set layout to Landscape */
    body {
      width: ${subReportsName === 'Income Report' ? '45vw' : '100vw'};
      position: absolute;
      left:${subReportsName === 'Income Report' ? '30%' : ''};
      right:${subReportsName === 'Income Report' ? '30%' : ''};
    }
  @media print {
    .printable {
      display: block !important;
    }
    .not_printable{
    display:none !important
    }
  }
`;
  const PrintRef = useRef<any>(null);

  const handlePrint = useReactToPrint({
    content: () => PrintRef.current,
    documentTitle: "Print Document",
    suppressErrors: true,
    pageStyle: PrintStyles,
  });

  const handleExportAndPrint = async () => {
    await convertToPrint();
    setIsPrintTriggered(true);
  };
  
  useEffect(() => {
    if (isPrintTriggered && excelData.length > 0 && excelData.length < 15000) {
      handlePrint();      
      setIsPrintTriggered(false);
    }else if(excelData && excelData.length > 15000){
      // alert('Print Limit is exceeded, Please use Export to Excel')
      toast.custom(
        <ErrorPopup
          headerTitle="Attention"
          showMessage="Print Limit is exceeded, Please use Export to Excel"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        }
      );
      setExcelData([])
    }else{
      setExcelData([])
    }
  }, [excelData, isPrintTriggered,handlePrint]);

  useEffect(()=>{
    setExcelData(excelData)
  },[excelData,treasuryReportsReqBody])

  const convertToPrint = useCallback(async ()=>{
    try{
      let reqBody: any = treasuryReportsReqBody;
      let endpoint: string = "";  
      let requiredKeys; 

      switch (subReportsName) {
        case "Drill Down Report":
          requiredKeys = ['searchStartDate', 'searchEndDate','donationTypeId','donationsPurposeId','poojaTypeId'];
          reqBody = {};
          requiredKeys.forEach(key => {
            if (treasuryReportsReqBody.hasOwnProperty(key)) {
              reqBody[key] = treasuryReportsReqBody[key];
            }
          });
          endpoint =
            "/report-dashboard/reports/treasury/INCOME_REPORT_DONATION_POOJA_REPORT/browser";
          break;
          case "Donation Report" :
            requiredKeys = ['searchStartDate', 'searchEndDate','searchCriteria','searchAmount','searchAmountUpperLimit'];
            reqBody = {};
            requiredKeys.forEach(key => {
              if (treasuryReportsReqBody.hasOwnProperty(key)) {
                reqBody[key] = treasuryReportsReqBody[key];
              }
            });
            endpoint= "/report-dashboard/reports/treasury/DONATION_REPORT/browser"; 
            break;
          case "Revenue Reports" :
              requiredKeys = ["donationDate","searchUserName","serviceType"];
              reqBody = {};
              requiredKeys.forEach(key => {
                if (treasuryReportsReqBody.hasOwnProperty(key)) {
                  reqBody[key] = treasuryReportsReqBody[key];
                }
              });
              endpoint= "/report-dashboard/reports/revenue/REVENUE_REPORT/browser"; 
              break;
          case "Revenue Summary Report by Signin Name" :
              requiredKeys = ["searchStartDate","searchUserName","searchEndDate"];
              reqBody = {};
              requiredKeys.forEach(key => {
                if (treasuryReportsReqBody.hasOwnProperty(key)) {
                  reqBody[key] = treasuryReportsReqBody[key];
                }
              });
              endpoint= "/report-dashboard/reports/REVENUE_SUMMARY_REPORT_BY_SIGN_IN_NAME/browser"; 
              break;
        default:
          break;
      }
      setPrintBtnLoading(true);
      if (endpoint) {
       const res =  await apiRequest({
          method: "POST",
          endpoint: endpoint,
          body: JSON.stringify(reqBody),
          includeToken: true,
        })
         let counter = 1;
         let response;
         if(subReportsName === 'Drill Down Report'){
          response = res.data.data.map((drillItem:any)=>{
                return {
                   "Sr No":drillItem.sno || counter++,
                   "Receipt Number":drillItem.receiptnumber,
                   "Reference Number":drillItem.referencenumber,
                   "Name (Sign-in)":drillItem.name,
                   "Mode of Payment":drillItem.modeofpayment,
                   "Check Number":drillItem.checknumber,
                   "Description":drillItem.description,
                   "Donation/Puja (ID)":drillItem.donationpoojaid,
                   "Date of Payment":drillItem.dateofpayment,
                   "Amount":formatAmount(drillItem.amount),
                   type:drillItem.type
                }
          })
         }else if(subReportsName === 'Donation Report'){
                response = res.data[0].data.map((report:any)=>{
                  return {
                    "Sr.No.":counter++,
                    "Sign-in Name":report.username,
                    "Name":report.fullName,
                    "Address":report.address,
                    "Home Phone":report.phoneresidence,
                    "Email":report.email,
                    "Donation Amount":formatAmount(report.donationamount),
                    "Refund Amount":formatAmount(report.refundamount),
                }
            })
         }else if(subReportsName === 'Revenue Reports'){
              response = res.data.data.map((report:any)=>{
                return {
                  "Sr.No": report.sno,
                  "Receipt Number": report.receiptnumber,
                  "Reference Number": report.referencenumber,
                  "Name (Sign-in)":report.fullname,
                  "Mode of Payment": report.donationtype,
                  "Check Number": report.checknumber,
                  "Donation/Puja (ID)":report.poojaname,
                  "Date of Payment":report.dateofdonation,
                  "Amount":formatAmount(report.amount),
                  ...(report.onwhosename && { "Description": report.onwhosename }),
                  ...(report.phoneresidence && { "Home Phone": report.phoneresidence }),
                  ...(report.email && { "Email": report.email }),
                };
          })
        }else if(subReportsName === 'Revenue Summary Report by Signin Name'){
          response = res.data.data.map((value: any) => {
            return {
              "Date": value.dateofpayment,
              "Name (Sign-in)": value.username,
              "Pooja Booking": value.poojabookingamount ? formatAmount(value.poojabookingamount) : '' ,
              "Donation": value.donationamount ? formatAmount(value.donationamount) : '',
              "Hall Rental": value.hallrentalamount ? formatAmount(value.hallrentalamount) : '',
              "Prasadam": value.prasadamamount ? formatAmount(value.prasadamamount) : '',
              "Calendar": value.calendaramount ? formatAmount(value.calendaramount) : '',
              "Others": value.othersamount ? formatAmount(value.othersamount) : '',
            };
          });
        }
        setExcelData(response);
        let  columnHeaders = response[0]
        let columns: any = {};
        for (let key of Object.keys(columnHeaders)) {
          columns[key] = key;
        }
        setExcelColumnData(columns)  
        setPrintBtnLoading(false)
      } else {
        setPrintBtnLoading(false)
        console.error("Invalid subReportsName");
      }
    }catch(error) {
      setPrintBtnLoading(false)
      console.error('Error downloading Excel file:', error);
    }
  },[subReportsName, treasuryReportsReqBody])

  const ExportToExcel = async () => {
    try{
      let reqBody: any = treasuryReportsReqBody;
      let endpoint: string = "";
      let requiredKeys; 
  
      switch (subReportsName) {
        case "Daily Check Receipt Report":
          endpoint =
            "/report-dashboard/reports/treasury/DAILY_CHECK_RECEIPT_REPORT/excel";
          break;
        case "Income Report":   
          reqBody = incomeReportReqBody       
          endpoint =
            "/report-dashboard/reports/treasury/INCOME_REPORT/excel";
          break;
        case "Drill Down Report":
          requiredKeys = ['searchStartDate', 'searchEndDate','donationTypeId','donationsPurposeId','poojaTypeId'];
          reqBody = {};
          requiredKeys.forEach(key => {
            if (treasuryReportsReqBody.hasOwnProperty(key)) {
              reqBody[key] = treasuryReportsReqBody[key];
            }
          });
          endpoint =
            "/report-dashboard/reports/treasury/INCOME_REPORT_DONATION_POOJA_REPORT/excel";
          break;
        case "Special Event Donation Report":
          endpoint = apiPath.specialEventDonationReport_excel           
          break;
          case "Lifetime Donors Report" :
            endpoint= "/report-dashboard/reports/treasury/LIFETIME_DONORS_REPORT/excel"; 
            break;
          case "Donation Report" :
            requiredKeys = ['searchStartDate', 'searchEndDate','searchCriteria','searchAmount','searchAmountUpperLimit'];
            reqBody = {};
            requiredKeys.forEach(key => {
              if (treasuryReportsReqBody.hasOwnProperty(key)) {
                reqBody[key] = treasuryReportsReqBody[key];
              }
            });
            endpoint= "/report-dashboard/reports/treasury/DONATION_REPORT/excel"; 
            break;
          case "Donation Pooja Report" :
            endpoint= "/report-dashboard/reports/treasury/DONATION_PUJA_REPORT/excel"; 
            break;
          case "Revenue Reports" :
              reqBody.pagination = false;
              endpoint= "/report-dashboard/reports/revenue/REVENUE_REPORT/excel"; 
              break;  
          case "Revenue Summary Report by Signin Name" :
              requiredKeys = ["searchStartDate","searchUserName","searchEndDate"];
              reqBody = {};
              requiredKeys.forEach(key => {
                if (treasuryReportsReqBody.hasOwnProperty(key)) {
                  reqBody[key] = treasuryReportsReqBody[key];
                }
              });
              endpoint= "/report-dashboard/reports/REVENUE_SUMMARY_REPORT_BY_SIGN_IN_NAME/excel"; 
              break;  
          case "Revenue Summary Report" :
              endpoint= "/report-dashboard/reports/treasury/REVENUE_SUMMARY_REPORT/excel"; 
              break;  
        default:
          break;
      }
      setLoading(true);
      if (endpoint) {
       const response =  await apiRequest({
          method: "POST",
          endpoint: endpoint,
          body: JSON.stringify(reqBody),
          includeToken: true,
          responseType: 'arraybuffer'
        })
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${subReportsName === 'Drill Down Report' ? 'INCOME_REPORT_DONATION_POOJA_REPORT' :subReportsName}.xlsx`;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        setLoading(false)
      } else {
        setLoading(false)
        console.error("Invalid subReportsName");
      }
    }catch(error) {
      setLoading(false)
      console.error('Error downloading Excel file:', error);
    }
  };
  
  const displayReportName = ()=>{
      switch(subReportsName){
        case "Daily Check Receipt Report":
          return "Daily Check Receipt Report"
        case "Donation Report" :
          return `Donation Report from ${treasuryReportsReqBody.searchStartDate} to ${treasuryReportsReqBody.searchEndDate}`
        case "Donation Pooja Report" :
          return `Donation Pooja Report from ${treasuryReportsReqBody.searchStartDate} to ${treasuryReportsReqBody.searchEndDate}`  
        case "Income Report" :
          return "Income Report"  
        case "Drill Down Report" :
          return "Income Report"  
        case "Special Event Donation Report" :
          return `Special Event Donation Report (${treasuryReportsReqBody.specialEventName})
          from ${treasuryReportsReqBody.searchStartDate} to ${treasuryReportsReqBody.searchEndDate}`  
        case "Lifetime Donors Report" :
          return "Life Time Donors Report"  
        case "Revenue Reports" :
          return "Revenue Report"  
        case "Revenue Summary Report by Signin Name" :
          // return `Revenue Report from ${treasuryReportsReqBody.searchStartDate} to ${treasuryReportsReqBody.searchEndDate}` 
          return (
            <>
            {selectMonth ? 
            (<span>Revenue Report ({`Month : ${selectMonth}`}, Year : {selectYear ? selectYear : ''})</span>)
            : selectQuarter ? 
            (<span>Revenue Report ({`Quarter : ${selectQuarter}`}, Year : {selectYear ? selectYear : ''})</span>)
            : (<span>Revenue Report from {dayjs(treasuryReportsReqBody.searchStartDate).format('MM/DD/YYYY')} to {dayjs(treasuryReportsReqBody.searchEndDate).format('MM/DD/YYYY')}</span>)
            }
            </>
          )
        case "Revenue Summary Report" : 
          const keysToCheck = ['quarterlySearch', 'weeklySearch', 'monthlySearch'];
          const existingKey = keysToCheck.find(key => Object.keys(treasuryReportsReqBody).includes(key));
          const searchBy = existingKey?.split('S')[0]
          const searchName = `${searchBy?.charAt(0).toUpperCase()}${searchBy?.slice(1)}` 
          // return `${searchName} Revenue Summary Report (${treasuryReportsReqBody.searchStartDate})`
          return (
            <>
            {selectMonth ? 
            (<span>{`${searchName} Revenue Summary Report (${selectMonth}, ${selectYear})`}</span>)
            : selectQuarter ? 
            (<span>{`${searchName} Revenue Summary Report (${selectQuarter},${selectYear})`}</span>)
            : (<span>{`${searchName} Revenue Summary Report (${treasuryReportsReqBody.searchStartDate})`}</span>)
            }
            </>
          )
        default:
          break;
      }
  }

 const getHandlePrint = ()=>{
  switch(subReportsName){
    case 'Drill Down Report':
    case 'Donation Report':
    case 'Revenue Reports':
    case 'Revenue Summary Report by Signin Name':
      return handleExportAndPrint()
    default:
      return handlePrint() 
  }
 }
  const cumulativeAmount = (amount: number) => {
    setTotalCumAmt((prevValue: number) => prevValue + amount);
  }

  useEffect(() => {
    if(subReportsName === 'Donation Pooja Report'){
      let cumulativeNetAmount = 0;
      let cumulativeTotalAmount = 0;
      
      if (treasuryReportData) {
       treasuryReportData.forEach((report: any) => {
          const key = Object.keys(report)[0];
          const totalNetAmount = parseFloat(report[key]['Total Net Amount']) || 0;
          const totalAmount = parseFloat(report[key]['Total Amount']) || 0;
  
          if (['donationList', 'poojaDonation', 'vastraList'].includes(key)) {
            cumulativeNetAmount += totalNetAmount;
          }
  
          if (['dafDonationList', 'mdDonationList'].includes(key)) {
            cumulativeTotalAmount += totalAmount;
          }
          if(key === 'donationList'){
            setTotalDonation(totalNetAmount)
          }else if(key === 'poojaDonation'){
            setTotalPooja(totalNetAmount)
          }
        });
        const totalCumulativeAmount = cumulativeNetAmount + cumulativeTotalAmount;
        setTotalCumAmt(totalCumulativeAmount);
      }
    }
  }, [treasuryReportData]);
  return (
    <>
      {!dataFromChild ? (
        <div className={styles.poojareportsLayout}>
          <Typography className={styles.typoGraphyHeader}>
            Treasury Reports
          </Typography>
          <Card className={styles.cardContainer}>
            <Grid container columnSpacing={"12px"} rowSpacing={"10px"}>
            {subReports &&
              subReports.subMenus.map((report: any, index: any) => (
                <Grid item xs={12} md={expandedPanel === index ? 12: 6} key={index}>
                  <Accordion
                    sx={{
                      border: subReportsAccordiansArray[index]
                        ? "1px solid #F05802"
                        : "1px solid #989898",
                      background: "#FFF9E4",
                      boxShadow: "none",
                      borderRadius: "8px",
                      ".MuiAccordionSummary-content.Mui-expanded": {
                        my: "12px"
                      },
                      ".MuiAccordionSummary-root.Mui-expanded": {
                        minHeight: "auto"
                      },
                    }}
                    expanded={expandedPanel === index}
                    // expanded={subReportsAccordiansArray[index]}
                    onChange={() => handleToggleChange(index)}
                  >
                    <AccordionSummary
                      aria-controls={`panel-content`}
                      id={`panel--header`}
                    >
                      <Box sx={{display: "flex", alignItems: "center"}}>
                        <Box className={styles.iconstyles}>
                          {expandedPanel === index ? (
                            <CustomUpIcon />
                          ) : (
                            <CustomDownIcon />
                          )}
                        </Box>
                        <Typography
                          className={"sub_heading"}
                          style={{fontWeight: "500", fontSize: "16px"}}
                        >
                          {report.title}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{p: "0px 16px 16px 16px"}}>
                      {ReportToRender(
                        report.key,
                        handleDataFromChild,
                        getReportData,
                        getReqBodyAndResData
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </Card>
        </div>
      ) : (
        <Box ref={PrintRef}>
          {!printActive && <Toaster />}
          <Typography
            sx={{
              fontFamily: "Lato",
              fontSize: "20px",
              fontWeight: 500,
              color: "#882E14",
              display: "flex",
              gap: "10px",
            }}
          >
            <span
              style={{ margin: "4px 0" }}
              onClick={handleGoingBackToMainReportsSection}
              className="no_print"
            >
              <CustomLeftIcon />
            </span>
            <span className={!printActive && (subReportsName === 'Income Report' || subReportsName === 'Drill Down Report') ? 'not_printable' : ''}>
                  {displayReportName()}
             </span>
            <Box 
              sx={{
                display: "flex",
                gap: "16px",
                marginLeft: "auto",
                float: "right",
              }}
            >
              <CommonOutlinedButton onClick={getHandlePrint}
              className="no_print" 
                disabled={printBtnLoading || treasuryReportData.length === 0}>
              <ButtonLoader
                  isBtnLoading={printBtnLoading}
                  btnText={"Print"}
                />
              </CommonOutlinedButton>
              <CommonButton
                style={{ whiteSpace: "nowrap" }}
                onClick={ExportToExcel}
                disabled={loading || treasuryReportData.length === 0}
                className="no_print"
              >
                <ButtonLoader
                  isBtnLoading={loading}
                  btnText={"Export To Excel"}
                />
              </CommonButton>
            </Box>
          </Typography>
          {reportName === "IncomeReport" ? (
            <IncomeReportTableData
              tableHeaders={columnData}
              ReportData={treasuryReportData}
              sendDataToParent={handleDataFromChild}
              getReportData={getReportData}
              getTotalDrillDownData={getTotalDrillDownData}
              sendDrillDownRequestBody={sendDrillDownRequestBody}
              reqBody={reqBody}
              resData={resData}
            />
          ) : reportName === "DrillDownReport" || 
              subReportsName === "Revenue Reports" || 
              subReportsName === "Revenue Summary Report by Signin Name" ? (
            <>
            <div className="no_print">
              <TreasuryIncomeReportsTableData
                tableHeaders={columnData}
                ReportData={treasuryReportData}
                totalDonatedAmount={totalDonatedAmount}
                totalDrillDownData={totalDrillDownData}
                requestBodyDrillDown={requestBodyDrillDown}
                reportName={reportName || subReportsName}
                totalElements_DonationReport={totalElements_DonationReport}
                pageSize_DonationReport={pageSize_DonationReport}
                devoteeName={devoteeName}
              />
            </div>
            {excelData && excelData.length > 0 && <div className="printable" style={{display:'none'}}>
                  <PrintTreasuryReports
                      tableHeaders={excelColumnData}
                      ReportData={excelData}
                      totalDonatedAmount={totalDonatedAmount}
                      reportName={subReportsName}
                      requestBodyDrillDown={requestBodyDrillDown}
                      devoteeName={devoteeName}
                   />
              </div>}
            </>
          ) : reportName === 'SpecialEventDonationReport' ? 
              (<>              
              {treasuryReportData.length === 0 &&
                <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}>
                  <b>No Records found</b>
                </Typography>
              }
                {treasuryReportData?.map((data, index: number) => (
                  <Box>
                    {data.userinfo && data.userinfo.length > 0 && (
                      <Box
                        key={index}
                        style={{
                          fontWeight: "700",
                          fontSize: "16px",
                          margin: "10px 0 2px 0",
                        }}
                      >
                        {data.deityname}
                      </Box>
                    )}
                    {data.userinfo && data.userinfo.length > 0 && (
                      <SpecialEventsReportsTableData
                        tableHeaders={columnData}
                        ReportData={data.userinfo}
                      />
                    )}
                  </Box>
                ))}    
                </>           
              )
          : subReportsName === "Lifetime Donors Report" ? (
            <>
            <LifeTimeDonarsTableData
                tableHeaders={columnData}
                ReportData={treasuryReportData}
              />
            </>

          ) :subReportsName === "Donation Pooja Report" ?
              <>
                {treasuryReportData && treasuryReportData.map((report:any,i:number)=>{
                   const key = Object.keys(report)[0];
                   const { headers, data, name } = report[key];
                   const totalAmount = report[key]['Total Amount'];
                   const totalNetAmount = report[key]['Total Net Amount'];
                   const totalRefunds = report[key]['Total Refunds'];
                   return (
                    data?.length > 0 && <DonationPoojaReportTableData
                    key={i}
                        tableHeaders={headers}
                        ReportData={data}
                        reportName={subReportsName}
                        name={name}
                        formDataInfo={formDataInfo}
                        getCumulativeAmount={cumulativeAmount}
                        amountsTotal={{totalAmount,totalNetAmount,totalRefunds}}
                        totalPoojaAmount={totalDonation + totalPooja}
                      /> )
                })}
                { totalCumAmt === 0 &&
                  <Typography sx={{margin:"24px auto",color:"red",fontSize:"28px",textAlign:'left'}}>
                    <b>No Records found</b>
                  </Typography>
                }
                <div style={{ backgroundColor: '#F2BE22',display:'flex',justifyContent:'space-between',padding:'10px',marginTop:'15px' }}>
                      <span>
                        <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'Cumulative Total' }} />
                      </span>
                      <span  style={{ textAlign: 'end' }}>
                        <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(totalCumAmt) }} />
                      </span>
                </div>
               </>
              : (
                <>
                <div className={subReportsName === 'Donation Report' ? "no_print" : ''}>
                    <TreasuryReportsTableData
                      tableHeaders={columnData}
                      ReportData={treasuryReportData}
                      reportName={subReportsName}
                      formDataInfo={formDataInfo}
                      totalElements_DonationReport={totalElements_DonationReport}
                      pageSize_DonationReport={pageSize_DonationReport}
                      treasuryReportsReqBody={treasuryReportsReqBody}
                    />
                </div>
                {excelData && excelData.length > 0 && <div className="printable" style={{display:'none'}}>
                      <PrintTreasuryReports
                          tableHeaders={excelColumnData}
                          ReportData={excelData}
                          reportName={subReportsName}                          
                          formDataInfo={formDataInfo}
                      />
                  </div>}
              </>
          )}
        </Box>
      )}
    </>
  );
};

export default TreasuryReports;
